import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile, isTablet } from "../../../@css-style";

export const ElBenefit = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 5em 0;
  background-attachment: fixed; /* KEY for parallax */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  ${isMobile} {
    padding: 2em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElBenefitContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 2em;
  padding: 10px;
  align-items: center;
  justify-content: flex-start;
`;

export const ElColumn = styled.div<{ "data-color"?: string }>`
  width: 33.33%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  /* padding: 2em; */
  gap: 1em;
  text-align: left;
  background-color: var(--theme-main-secondary-color);
  border-radius: 25px;
  padding: 1.5em;
  height: 100%;
  img {
    max-width: 100%;
    width: 100%;
    height: auto;
    object-fit: contain;

    border-radius: 10px;
    background-color: #fff;
  }
  h2 {
    font-size: 36px;
    display: block;
    width: 100%;
    color: #ffffff;
    font-weight: 700;
    color: #fff;
    &[data-color="green"] {
      color: var(--theme-main-green-color);
      text-shadow: 0px 0px 15px rgba(255, 244.37821361058602, 233.38043478260872, 0.87);
    }
  }
  h3 {
    color: #fff;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%; /* 30px */
    letter-spacing: -0.48px;
    [data-color="green"] {
      color: var(--theme-main-green-color);
      /* text-shadow: 0px 0px 15px rgba(255, 244.37821361058602, 233.38043478260872, 0.87); */
    }
  }

  p {
    color: #fff;
    font-size: 15px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    gap: 10px;
    line-height: 1.6em;
  }
  a {
    font-size: 15px;
    font-weight: 400;
    color: var(--theme-main-color);
  }
  ${isMobile} {
    width: 100% !important;
    height: auto;
    /* justify-content: center; */
    /* align-items: center; */
    flex: none !important;
  }
`;

export const elGapBenefit = css`
  gap: 20px;
  position: relative !important;
  z-index: 2 !important;
`;

export const elBgWhite = css`
  border-radius: 10px;
`;
